import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuestionareService } from '../questionare.service';
import { Questionare, Question, TypeOfQuestion } from '../objects/Questionare';

@Component({
  selector: 'app-add-questionare',
  templateUrl: './add-questionare.component.html',
  styleUrls: ['./add-questionare.component.css']
})
export class AddQuestionareComponent {
  questionareForm: FormGroup;
  questionForm: FormGroup;
  saving = false;
  isEditMode: boolean;
  addingQuestion = false;
  questions: Question[] = [];

  readonly questionTypes = [
    { value: TypeOfQuestion.ShortAnswer,    label: 'Short Answer' },
    { value: TypeOfQuestion.TrueFalse,      label: 'True / False' },
    { value: TypeOfQuestion.MultipleChoice, label: 'Multiple Choice' },
    { value: TypeOfQuestion.MultipleAnswer, label: 'Multiple Answer' },
  ];

  constructor(
    private fb: FormBuilder,
    private questionareService: QuestionareService,
    private dialogRef: MatDialogRef<AddQuestionareComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { questionare?: Questionare }
  ) {
    const q = data?.questionare;
    this.isEditMode = !!q?.id;
    this.questions = q?.questions ? [...q.questions] : [];

    this.questionareForm = this.fb.group({
      questionareCategory:    [q?.questionareCategory    ?? '', Validators.required],
      subCategory:            [q?.subCategory            ?? '', Validators.required],
      questionareName:        [q?.questionareName        ?? '', Validators.required],
      questionareDescription: [q?.questionareDescription ?? '', Validators.required],
    });

    this.questionForm = this.fb.group({
      category:       ['', Validators.required],
      description:    ['', Validators.required],
      typeOfQuestion: [TypeOfQuestion.ShortAnswer, Validators.required],
      answer:         [''],
    });
  }

  readonly TFQ = TypeOfQuestion; // expose to template

  get currentType(): number {
    return this.questionForm.get('typeOfQuestion')?.value ?? TypeOfQuestion.ShortAnswer;
  }

  typeLabel(type: TypeOfQuestion | string): string {
    return this.questionTypes.find(t => t.value === type)?.label ?? String(type);
  }

  startAddQuestion(): void {
    this.addingQuestion = true;
    this.questionForm.reset({ typeOfQuestion: TypeOfQuestion.ShortAnswer });
  }

  cancelAddQuestion(): void {
    this.addingQuestion = false;
    this.questionForm.reset({ typeOfQuestion: TypeOfQuestion.ShortAnswer });
  }

  addQuestion(): void {
    if (this.questionForm.invalid) return;
    this.questions = [...this.questions, { ...this.questionForm.value }];
    this.addingQuestion = false;
    this.questionForm.reset({ typeOfQuestion: TypeOfQuestion.ShortAnswer });
  }

  removeQuestion(index: number): void {
    this.questions = this.questions.filter((_, i) => i !== index);
  }

  onSubmit(): void {
    if (this.questionareForm.invalid) return;
    this.saving = true;

    const payload: Questionare = {
      ...this.questionareForm.value,
      questions: this.questions,
    };

    const call$ = this.isEditMode
      ? this.questionareService.updateQuestionare(this.data.questionare!.id!, payload)
      : this.questionareService.addQuestionare(payload);

    call$.subscribe({
      next: (result) => { this.saving = false; this.dialogRef.close(result); },
      error: () => { this.saving = false; }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
